const wx = require('jweixin-module')
const ACCESS_ZST = 'ZST'  // 中山通（引流来源入口）

import { getWechat } from '@/api/zhibo'
import { buildUrl, GetParam } from '@/utils/getParam.js'
import router from '@/router'
import store from '@/store'

// 记录最近一次页面设置的分享数据（标题、图片等），用于路由变化时保留配置，仅更新链接
let lastShareData = {}

export const wexinShare = (shareData = {}) => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  // 按微信 JSSDK 要求，参与签名的 URL 需去掉 hash（# 后内容）
  // iOS 仍沿用首屏进入时的 URL（保存在 wxSignUrl），非 iOS 用当前地址去掉 hash
  let pageUrl = location.href.split('#')[0]
  if (isiOS) {
    pageUrl = store.state.wxSignUrl
  }
  const http = window.location.protocol + '//'
  const url = window.location.hostname // 获取当前访问（域名）
  const pic = http + url + '/logo.jpg'
  // 合并本次配置与历史配置，优先使用最新的字段；link 始终更新为当前地址
  lastShareData = { ...lastShareData, ...shareData }
  // 为避免微信在 PC 端去掉 hash 导致进入首页，这里将分享链接设置为带参数的根路径，
  // 由应用在启动时读取 `path` 参数并还原到目标路由。
  // 优先使用sessionStorage中缓存的当前路径
  const cachedPath = sessionStorage.getItem('currentPath')
  const currentFullPath = cachedPath || (router && router.currentRoute && router.currentRoute.fullPath
    ? router.currentRoute.fullPath
    : (window.location.hash ? window.location.hash.replace(/^#/, '') : '/'))
  const mergedShare = {
    title: lastShareData.title || '精品中山',
    desc: lastShareData.desc || '精品中山',
    imgUrl: lastShareData.imgUrl || pic,
    link: window.location.origin + `/?path=${encodeURIComponent(currentFullPath)}`
  }

  getWechat({
    liveUrl: pageUrl
  }).then(res => {
    var weChat = res.data
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      appId: weChat.appId, // 必填，公众号的唯一标识
      timestamp: weChat.timestamp, // 必填，生成签名的时间戳
      nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
      signature: weChat.signature, // 必填，签名
      jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData', 'showMenuItems'],
      openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData', 'showMenuItems'] // 跳转小程序时必填
    })
    wx.checkJsApi({
      jsApiList: ['chooseImage', 'updateAppMessageShareData', 'showMenuItems'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      }
    })
    wx.ready(function () {
      wx.showMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:share:facebook", "menuItem:share:QZone", "menuItem:favorite", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:refresh", "menuItem:copyUrl", "menuItem:setFont"],  // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        success: function (res) {
          // 隐藏菜单成功
          console.log('显示成功', res)
        },
        fail: function (res) {
          // 隐藏菜单失败
          console.log('显示失败', res)
        }
      });
      //分享到朋友圈”及“分享到QQ空间”
      wx.updateTimelineShareData({
        ...mergedShare,
        success: function (res) {
          // 设置成功
        }
      })

      // “分享给朋友”及“分享到QQ”
      wx.updateAppMessageShareData({
        ...mergedShare,
        success: function (res) {
        }
      })
      // 旧版本
      wx.onMenuShareAppMessage({
        ...mergedShare,
        success: function (e) {
          // 用户点击了分享后执行的回调函数
        }
      })
    })
    wx.error(function (res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
  })
}

// 路由变化时刷新分享配置：保留上一次的标题/图片，只更新当前链接与签名
export const refreshShare = () => {
  return wexinShare({})
}

export const hideShare = () => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  let pageUrl = location.href
  if (isiOS) { // ios
    // ios系统就拼接随机字符串
    pageUrl = store.state.wxSignUrl
  }
  getWechat({
    liveUrl: pageUrl, // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
    jsApiList: ['hideAllNonBaseMenuItem', 'hideAllNonBaseMenuItem']
  }).then(res => {
    if (res.code !== 200) {
      return
    }
    var weChat = res.data
    console.log('hideShare', weChat)
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      appId: weChat.appId, // 必填，公众号的唯一标识
      timestamp: weChat.timestamp, // 必填，生成签名的时间戳
      nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
      signature: weChat.signature, // 必填，签名
      jsApiList: weChat.jsApiList,
    })
    wx.ready(function () {
      wx.hideAllNonBaseMenuItem()
      wx.showMenuItems({
        menuList: ["menuItem:favorite", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:refresh", "menuItem:copyUrl", "menuItem:setFont"],  // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        success: function (res) {
          // 隐藏菜单成功
          console.log('显示成功', res)
        },
        fail: function (res) {
          // 隐藏菜单失败
          console.log('显示失败', res)
        }
      });
    })
    wx.error(function (res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('报错', res)
    })
  })


  // wx.hideOptionMenu()
}

/**
 * 获取code（前端直接拼接授权链接，通过Hub认证中心）
 *
 * @param {string} fullPath  回调路径
 * @param {string} scope  请求的类型：snsapi_userinfo（获取全部信息）| snsapi_base（只获取openid，默认）
 */
export function getCode(fullPath, scope) {
  scope = scope == 'snsapi_userinfo' ? 'snsapi_userinfo' : 'snsapi_base'
  const href = buildUrl(fullPath || window.location.href)

  // 获取配置
  const appId = 'wxd0ec5e5e72a9a9b7'; // 微信公众号AppID
  // const appId = process.env.VUE_APP_ID; // 微信公众号AppID
  const hubWebUrl = process.env.VUE_APP_HUB_WEB_URL // Hub前端地址

  // 【所有授权都通过Hub认证中心】
  // 因为微信公众号授权域名配置的是Hub地址，不是Web地址
  console.log(`getCode: ${scope === 'snsapi_base' ? '静默授权' : '授权登录'} (${scope})，通过Hub跳转`)

  // 构造 Hub 认证页地址（带上target参数）
  const hubAuthPage = `${hubWebUrl}/#/auth-hub`
  const targetParam = encodeURIComponent(href)
  const redirectUri = `${hubAuthPage}?target=${targetParam}`

  // 拼接微信授权链接
  // 注意：redirect_uri 必须是Hub地址，因为微信授权域名配置的是Hub
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?` +
    `appid=${appId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&response_type=code` +
    `&scope=${scope}` +
    `&state=${scope}` + // 用scope作为state，方便后端识别
    `#wechat_redirect`
}

/**
 * 微信浏览器
 * @returns bool
 */
export function isWechatBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
}

/**
 * 支付宝浏览器
 * @returns bool
 */
export function isAlipayBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.match(/Alipay/i) == 'alipay') {
    return true
  }
  return false
}

/**
 * ios/mac系统
 * @returns bool
 */
export function isIos() {
  return navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac OS') > -1
}

/**
 * 微信或支付宝浏览器
 * @returns bool
 */
export function isWechatOrAlipayBrowser() {
  if (isWechatBrowser() || isAlipayBrowser()) {
    return true
  }
  // 检查是否在微信或支付宝浏览器中
  return false;
}

/**
 * PC适配处理
 * @returns void
 */
export function pcNextHanlde(to, from, next) {
  if (isWechatBrowser()) {
    next()
    next()
    return
  }
  // 生成唯一码
  // const guestId = localStorage.getItem('guest_id') || globalGuid()
  //localStorage.setItem('guest_id', guestId)
  let pcBoolean = localStorage.getItem('pcBoolean')
  const query = GetParam()
  if (!pcBoolean && query.pc) {
    pcBoolean = true
    localStorage.setItem('pcBoolean', pcBoolean)
  }

  // window.top === window 在iframe内  或  innerWidth > innerHeight横屏（电脑） 或  没有pc参数不跳转pc适配页面
  if (window.top === window && window.innerWidth > window.innerHeight && !pcBoolean) {
    window.location.href = `pc.html?path=${to.fullPath}`
  } else {
    next()
  }
}

/**
 * 主站引流跳转。
 */
export function mainWebsite(to, from, next, hasRedirected = false) {
  // 开机广告页
  if (to.path === '/adPage' && !isWechatMini() && to.query.access === ACCESS_ZST) {
    window.location.href = `${process.env.VUE_APP_SZZS_URL}${to.fullPath}`
    hasRedirected = true
  }
  return hasRedirected
}

/**
 * 微信小程序。
 */
export function isWechatMini() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.match(/MiniProgram/i) == 'miniProgram') {
    return true
  }
  return false
}
